import React, { useEffect, useState } from "react";
import _ from "lodash";
import { Link } from "react-router-dom";
import { useAtom } from "jotai";
import Fuse from "fuse.js";

import { refreshAtom } from "../../state/refreshPatientInfo";
import { userAtom } from "../../state/auth";
import { IPatient } from "../../types/patient";

import CardPatient from "./CardPatient";
import ConfirmAddPatient from "./ConfirmModalAddPatient";
import AddPatient from "./addPatient";
import Button from "../../components/ButtonUI";
import PatientInfo from "../../components/SharedPatientDetails";
import makeToast from "../../components/Snackbar";
import Pagination from "../../components/pagination";
import Input from "../../components/Input";

import { getAllDemandeData, getSuiviExportData, getAllMyPatients, retrivePatient } from "../../api/medecin";
import { verify } from "../../api/auth";
import { ReactComponent as IconSearch } from "../../assets/icons/icon-search.svg";
import { ReactComponent as Download } from "../../assets/illustrations/6421887411543238876.svg";
import "./styles.scss";

const MyPatients: React.FC = () => {
  const [user, setUser] = useAtom(userAtom);
  const [refreshPatientInfo] = useAtom(refreshAtom);
  const [isResponsable, setIsResponsable] = useState(
    user?.type === "medecinResponsable" ? true : false
  );
  const [filteredData, setFilteredData] = React.useState<any>([]);
  const [strFilter, setStrFilter] = React.useState<string>("");
  const [modalAddConfirm, setModalAddConfirm] = useState(false);
  const [modalAdd, setModalAdd] = useState(false);
  const [patientAdded, setPatientAdded] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState("");
  const [patientData, setPatientData] = useState<IPatient>();
  const [modal, setModal] = useState(false);
  const [listPatients, setListPatients] = useState([]);
  const [updatedPatient, setUpdatedPatient] = useState(false);
  const [colorIndex, setColorIndex] = useState(1);

  const handleDownload = () => {
    const exportUrl = `${process.env.REACT_APP_KATOMI_API_URL}/v1/demandes/exportdata`;
    window.location.href = exportUrl;
  };

  const fetchMyData = async () => {
    const response =
      user?.type === "medecinResponsable"
        ? await getAllMyPatients()
        : await verify();
    try {
      if (!isResponsable) {
        setUser({ ...response });
      } else {
        setListPatients(response);
      }
    } catch (error) {}
  };
  const combineAllKeyValues = (obj, separator = " ") => {
    separator = separator || " ";
    obj.fullName = obj.firstName + separator + obj.lastName;
    obj.InversedfullName = obj.lastName + separator + obj.firstName;
    if (obj.docExpert)
      obj.doctor.fullName =
        obj.doctor.firstName + separator + obj.doctor.lastName;
    return obj;
  };
  const handleListFiltering = () => {
    const patientsObj = isResponsable
      ? listPatients.map((s) => combineAllKeyValues(s))
      : user?.patients.map((s) => combineAllKeyValues(s));
    const fuse = new Fuse(patientsObj, {
      threshold: 0,

      shouldSort: true,
      keys: ["lastName", "firstName", "fullName", "InversedfullName", "motifs"],
    });
    const newList = fuse.search(strFilter).map((item) => {
      return item.item;
    });
    setFilteredData(newList);
  };
  const downloadCsvExport = async (
    fetchExport: () => Promise<{ blob: Blob; headers: Headers }>,
    fallbackFileName: string
  ) => {
    try {
      const { blob, headers } = await fetchExport();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      let fileName = fallbackFileName;
      const contentDisposition = headers.get("content-disposition");

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match?.[1]) fileName = match[1];
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      makeToast("success", "Téléchargement démarré");
    } catch (error) {
      makeToast("danger", "Erreur lors de l’exportation du fichier.");
    }
  };

  const handleExportAllData = () =>
    downloadCsvExport(getAllDemandeData, `export${Math.floor(Date.now() / 1000)}.csv`);

  const handleExportSuiviData = () =>
    downloadCsvExport(
      getSuiviExportData,
      `export_suivi_expertises_${Math.floor(Date.now() / 1000)}.csv`
    );
  useEffect(() => {
    if (patientAdded) {
      fetchMyData();
      setPatientAdded(!patientAdded);
    }
  }, [patientAdded]);
  useEffect(() => {
    if (isResponsable) {
      fetchMyData();
    }
  }, []);
  useEffect(() => {
    async function fetchMyAPI(): Promise<void> {
      let response: IPatient = await retrivePatient(selectedPatient, user?._id);
      const patient = response;
      if (!response) {
        makeToast("error", "Chargement de patient  à échouher.");
      }
      setPatientData({ ...patient });
    }

    if (selectedPatient) {
      fetchMyAPI();
      setModal(true);
      setPatientAdded(false);
      setUpdatedPatient(false);
    }
  }, [selectedPatient, updatedPatient, refreshPatientInfo?.state]);
  React.useEffect(() => {
    if (strFilter !== "") {
      handleListFiltering();
    }
  }, [strFilter, listPatients]);
  return (
    <>
      <div className="p-4 md:p-6 lg:p-8">
        <header className="flex flex-col md:flex-row justify-between items-start md:items-center w-full gap-4 mb-6">
          <div className="title-container">
            <h1 className="text-2xl font-bold text-gray-800">Mes patients</h1>
          </div>
        </header>

        <div className="flex flex-col lg:flex-row items-center gap-4 w-full mb-8">
          <div className="relative w-full lg:w-1/3 overflow-visible">
            <div className="absolute">
              <IconSearch className="w-5 h-5 text-gray-400 overflow-visible" />
            </div>

            <input
              type="text"
              placeholder="Rechercher patient"
              onChange={(e) => setStrFilter(e.target.value)}
              className="w-full h-12 pl-10 pr-3 border border-blue-100 rounded-xl bg-white text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm"
            />
          </div>

          <div className="flex flex-wrap justify-center md:justify-end items-center gap-3 w-full lg:flex-1">
            <Link
              to={"./Formulaireconsentement.docx"}
              target="_parent"
              download="Formulaireconsentement.docx"
              className="flex items-center justify-center px-4 py-3 min-w-[160px] h-[50px] bg-white border border-indigo-100 rounded-lg text-indigo-600 text-sm font-medium hover:bg-indigo-50 transition-colors"
            >
              <Download className="w-4 h-4 mr-2" />
              Consentement
            </Link>
            {isResponsable&&
              (
                <button
                  onClick={handleExportAllData}
                  className="flex items-center justify-center px-4 py-3 min-w-[160px] h-[50px] bg-white border border-indigo-100 rounded-lg text-indigo-600 text-sm font-medium hover:bg-indigo-50 transition-colors"
                >
                  <Download className="w-4 h-4 mr-2" />
                  Exporter
                </button>
              )
            }
            {isResponsable&&
              (
                <button
                  onClick={handleExportSuiviData}
                  className="flex items-center justify-center px-4 py-3 min-w-[160px] h-[50px] bg-white border border-indigo-100 rounded-lg text-indigo-600 text-sm font-medium hover:bg-indigo-50 transition-colors"
                >
                  <Download className="w-4 h-4 mr-2" />
                  Exporter suivi
                </button>
              )
            }


            <button
              onClick={() => setModalAddConfirm(true)}
              className="flex items-center justify-center px-4 py-3 min-w-[160px] h-[50px] bg-white border border-indigo-100 rounded-lg text-indigo-600 text-sm font-medium hover:bg-indigo-50 transition-colors"
            >
              + Nouveau patient
            </button>
          </div>
        </div>

        <div className="mt-8 w-full">
          {user?.patients.length !== 0 || listPatients.length !== 0 ? (
            <Pagination
              data={
                isResponsable
                  ? strFilter === ""
                    ? listPatients
                    : filteredData
                  : strFilter === ""
                  ? user?.patients
                  : filteredData
              }
              RenderComponent={CardPatient}
              pageLimit={50}
              Pages={() => {
                if (user?.type === "medecinResponsable") {
                  return Math.ceil(
                    strFilter === ""
                      ? listPatients.length / 10
                      : filteredData.length / 10
                  );
                } else if (user?.patients.length > 0) {
                  return Math.ceil(
                    strFilter === ""
                      ? user?.patients.length / 10
                      : filteredData.length / 10
                  );
                } else {
                  return 0;
                }
              }}
              dataLimit={10}
              modal={modal}
              setModal={setModal}
              setSelectedPatient={setSelectedPatient}
              selectedPatient={selectedPatient}
              setPages={strFilter === ""}
            />
          ) : (
            <div className="w-full flex flex-col items-center justify-center py-24 text-gray-500">
              <h3 className="text-xl font-medium">Aucun patient trouvé</h3>
            </div>
          )}
        </div>
      </div>

      {modalAdd && (
        <AddPatient
          openModal={modalAdd}
          setOpenModal={setModalAdd}
          setPatientAdded={setPatientAdded}
          setSelectedPatient={setSelectedPatient}
          setPatientData={setPatientData}
          setOpenModalInfoPatient={setModal}
          editMode={false}
          patientData={{
            _id: "",
            email: "",
            password: "",
            lastName: "",
            firstName: "",
            birthDate: "",
            birthday: "",
            sexe: [],
            gender: "",
            antecedents: [],
            phone: "",
            adresse: "",
            genez: "",
            numeroSecurite: "",
            medecin: "",
            codePostale: "",
          }}
        />
      )}

      {modal && (
        <PatientInfo
          setOpenModal={() => {
            setModal(false);
            setSelectedPatient("");
            setPatientData({} as any);
          }}
          setPatientAdded={setPatientAdded}
          setSelectedPatient={setSelectedPatient}
          setPatientData={setPatientData}
          setOpenModalInfoPatient={setModal}
          updatePatientData={setUpdatedPatient}
          patientData={patientData}
          colorIndex={colorIndex}
          openModal={modal}
        />
      )}

      {modalAddConfirm && (
        <ConfirmAddPatient
          openModal={modalAddConfirm}
          setOpenModal={setModalAddConfirm}
          setOpenModalAddPatient={setModalAdd}
        />
      )}
    </>
  );
};
export default MyPatients;
